import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import { TextButton, ContainedButton } from 'components/core/Button';
// Custom
import Callout from 'components/misc/Callout';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import ScrollerElement from 'components/misc/ScrollerElement';
import { CloseIconButton } from 'components/buttons/IconButtons';
import { SubFormRefContext } from '../misc/Contexts';

class SubFormTemplate extends React.Component {
  componentDidUpdate(prevProps) {
    // Check if enter key has been pressed
    const { enterPressed, onValidate } = this.props;
    const { enterPressed: prevEnterPressed } = prevProps;
    if (!prevEnterPressed && enterPressed) {
      onValidate();
    }
  }

  render() {
    const {
      title, infoText, errors, children, onCancel, onValidate,
    } = this.props;

    return (
      <SubFormRefContext.Consumer>
        {(subFormRef) => (
          <div>
            <div className="c-veil" />
            <ScrollerElement target="subForm" name={subFormRef}>
              <div className="box box-default m-0 c-subform">
                <div className="box-header box-dark box-title-small py-1 pr-1">
                  <div className="d-flex align-items-center">
                    <div style={{ flex: '1 1 auto' }}>
                      { title }
                    </div>
                    <div style={{ flex: '0 0 auto' }}>
                      <CloseIconButton onClick={onCancel} />
                    </div>
                  </div>
                </div>
                {infoText && (
                  <div className="px-3 pt-3">
                    <Callout>
                      {infoText}
                    </Callout>
                  </div>
                )}
                <div
                  className={
                    classnames('px-3 pb-3', {
                      'pt-3': errors,
                    })
                  }
                >
                  <ErrorsDisplayer errors={errors} />
                  { children }
                </div>
                <div className="box-header box-dark d-flex justify-content-end px-3 right-spaced-buttons">
                  <TextButton
                    label={<LocalizedMessage id="button.cancel" />}
                    onClick={onCancel}
                  />
                  <ContainedButton
                    label={<LocalizedMessage id="button.validate" />}
                    onClick={onValidate}
                  />
                </div>
              </div>
            </ScrollerElement>
          </div>
        )}
      </SubFormRefContext.Consumer>
    );
  }
}

SubFormTemplate.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  infoText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  errors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  enterPressed: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

SubFormTemplate.defaultProps = {
  infoText: null,
  errors: null,
  enterPressed: false,
};

module.exports = SubFormTemplate;



// WEBPACK FOOTER //
// ./components/templates/SubFormTemplate.js